module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lUxDi"))).then(() => parcelRequire('f4eak'));